var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Kuwait(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M20.958,31h21.757c0.01-0.028,0.02-0.056,0.031-0.083H20.958V31z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff3d00",
    d: "M42.716,31H20.958L9.914,38.194C13.529,41.781,18.505,44,24,44C32.579,44,39.875,38.588,42.716,31z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M20.958,30.917h21.788C43.543,28.758,44,26.435,44,24c0-2.467-0.468-4.818-1.284-7H20.958V30.917z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#689f38",
    d: "M42.716,17C39.875,9.412,32.579,4,24,4C18.505,4,13.529,6.219,9.914,9.806L20.958,17H42.716z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#37474f",
    d: "M20.958,30.917V17L9.914,9.806C6.263,13.43,4,18.45,4,24s2.263,10.57,5.914,14.194L20.958,31V30.917 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Kuwait);
export default __webpack_public_path__ + "static/media/icons8-kuwait.9755ce3f796347032fd307435853c50e.svg";
export { ForwardRef as ReactComponent };